<div
  class="modal fade"
  id="filtersModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="filtersModal"
  aria-hidden="true"
>
  <div class="modal-dialog" style="max-width: 1000px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ "Filtra calendario" | translate }}
        </h5>

        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="d-flex" #loadFilterDiv>
          <div class="form-group col-6">
            <label for="loadFilter"> {{ "Carica calendari personalizzati" | translate }} </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="loadFilter"
                [(ngModel)]="loadFilterId"
                (change)="selectFilter()"
              >
                <option [ngValue]="null">
                  {{ "Nessun calendario selezionato" | translate }}
                </option>

                <option
                  *ngFor="
                    let element of allFilters
                  "
                  [ngValue]="element.id"
                >
                  {{ element.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="d-flex" #partnerDiv>
          <div class="form-group col-12">
            <label for="partnerDiv">
              {{ "Partner" | translate }}
            </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="typeFilter"
                [(ngModel)]="filters.partner"
              >
                <option [ngValue]="null">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="let element of partnersList"
                  [value]="element"
                >
                  {{ element }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="form-group col-3" #typeDiv>
            <label for="typeDiv">
              {{ "Produzione" | translate }} / {{ "Rivendita" | translate }}
            </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="typeFilter"
                [(ngModel)]="filters.type"
              >
                <option [ngValue]="-1">
                  {{ "Nessun filtro" | translate }}
                </option>
                
                <option [ngValue]="1">
                  {{ "Produzione" | translate }}
                </option>

                <option [ngValue]="0">
                  {{ "Rivendita" | translate }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-4" #datefromDiv>
            <label>
              {{ "Da" | translate }}
            </label>

            <div>
              <input
                [(ngModel)]="filters.newFilterDate.from"
                style="width: 100%"
                type="date"
                class="form-control"
                id="datefrom"
                name="datefrom"
              />
            </div>
          </div>

          <div class="form-group col-4" #datetoDiv>
            <label>
              {{ "A" | translate }}
            </label>

            <div>
              <input
                [(ngModel)]="filters.newFilterDate.to"
                style="width: 100%"
                type="date"
                class="form-control"
                id="dateto"
                name="dateto"
              />
            </div>
          </div>

          <div class="form-group col-4" #statusDiv>
            <label for="orderstatusFilter">
              {{ "Status prenotazione" | translate }}
            </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="orderstatusFilter"
                [(ngModel)]="filters.orderstatus"
              >
                <option [ngValue]="-1">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option [ngValue]="0">
                  {{ "In Attesa" | translate }}
                </option>

                <option [ngValue]="1">
                  {{ "Accettata" | translate }}
                </option>

                <option [ngValue]="2">
                  {{ "Rifiutata" | translate }}
                </option>

                <option [ngValue]="3">
                  {{ "Processata" | translate }}
                </option>

                <option [ngValue]="4">
                  {{ "Cancellata" | translate }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex" #guestDiv>
          <div class="form-group col-4">
            <label>
              {{ "Nome ospite" | translate }}
            </label>

            <div>
              <input
                [(ngModel)]="filters.customername"
                type="text"
                style="width: 100%"
                class="form-control"
                id="customername"
                name="customername"
              />
            </div>
          </div>

          <div class="form-group col-4">
            <label>
              {{ "Cognome ospite" | translate }}
            </label>

            <div>
              <input
                [(ngModel)]="filters.customerlastname"
                type="text"
                style="width: 100%"
                class="form-control"
                id="customerlastname"
                name="customerlastname"
              />
            </div>
          </div>

          <div class="form-group col-4">
            <label>
              {{ "Email ospite" | translate }}
            </label>

            <div>
              <input
                [(ngModel)]="filters.customeremail"
                style="width: 100%"
                type="email"
                class="form-control"
                id="customeremail"
                name="customeremail"
              />
            </div>
          </div>
        </div>

        <div class="d-flex" #categoryDiv>
          <div class="form-group col-3">
            <label>
              {{ "Categoria root" | translate }}
            </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="categoryFilter0"
                [(ngModel)]="newCategoriesSelect.selectedCategory0"
                (change)="selectCategory(0)"
              >
                <option [ngValue]="null">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="
                    let element of newCategoriesSelect.categoryObj0.categories
                  "
                  [ngValue]="element.id"
                >
                  {{ element.title.it }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-3">
            <label> {{ "Categoria" | translate }} 1 </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="categoryFilter1"
                [(ngModel)]="newCategoriesSelect.selectedCategory1"
                (change)="selectCategory(1)"
              >
                <option [ngValue]="null">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="
                    let element of newCategoriesSelect.categoryObj1.categories
                  "
                  [ngValue]="element.id"
                >
                  {{ element.title.it }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-3">
            <label> {{ "Categoria" | translate }} 2 </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="categoryFilter2"
                [(ngModel)]="newCategoriesSelect.selectedCategory2"
                (change)="selectCategory(2)"
              >
                <option [ngValue]="null">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="
                    let element of newCategoriesSelect.categoryObj2.categories
                  "
                  [ngValue]="element.id"
                >
                  {{ element.title.it }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-3">
            <label> {{ "Categoria" | translate }} 3 </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="categoryFilter3"
                [(ngModel)]="newCategoriesSelect.selectedCategory3"
                (change)="selectCategory(3)"
              >
                <option [ngValue]="null">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="
                    let element of newCategoriesSelect.categoryObj3.categories
                  "
                  [ngValue]="element.id"
                >
                  {{ element.title.it }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex" #serviceDiv>
          <div class="form-group col-4">
            <label>
              {{ "Servizio" | translate }}
            </label>

            <div style="display: flex; flex-direction: row">
              <select
                class="form-control"
                name="categoryFilter1"
                [(ngModel)]="newCategoriesSelect.selectedServiceInList"
              >
                <option [ngValue]="null">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="let element of newCategoriesSelect.currentServiceList"
                  [ngValue]="element.id"
                >
                  {{ element.title.it }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-4">
            <label>
              {{ "Etichetta" | translate }}
            </label>

            <div>
              <select
                id="filterLabel"
                class="form-control"
                name="filterLabel"
                [(ngModel)]="filters.label"
              >
                <option [ngValue]="''">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="let element of allLabels"
                  [ngValue]="element.id"
                >
                  {{ element.name.it }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-4">
            <label>
              {{ "Reparto" | translate }}
            </label>

            <div>
              <select
                id="department"
                class="form-control"
                name="filterDepartment"
                [(ngModel)]="filters.department"
              >
                <option [ngValue]="''">
                  {{ "Nessun filtro" | translate }}
                </option>

                <option
                  *ngFor="let element of allDepartments"
                  [ngValue]="element.id"
                >
                  {{ element.name.it }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="clearFilter(true)">
          {{ "Resetta Filtri" | translate }}
        </button>

        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>

        <button
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          (click)="searchRequest()"
        >
          {{ "Conferma" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>